import { useEffect } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import {
    activeSegmentationsMapAtom,
    activeSwingIdAtom,
    activeVideoAtom,
    MAX_PROGRESS,
    pendingScrubberLockAtom,
    progressAtom,
    resolveTargetFrameFromPosition,
    scrubberLockAtom,
    totalFramesAtom,
} from '@store';

export const useResolvePendingScrubberLock = () => {
    const activeSwingId = useAtomValue(activeSwingIdAtom);
    const activeSegmentationsMap = useAtomValue(activeSegmentationsMapAtom);
    const activeVideo = useAtomValue(activeVideoAtom);
    const totalFrames = useAtomValue(totalFramesAtom);
    const scrubberLock = useAtomValue(scrubberLockAtom);
    const pendingScrubberLock = useAtomValue(pendingScrubberLockAtom);

    const setProgress = useSetAtom(progressAtom);
    const setPendingScrubberLock = useSetAtom(pendingScrubberLockAtom);

    useEffect(() => {
        if (!scrubberLock || !pendingScrubberLock || !activeSwingId) {
            if (!scrubberLock) setPendingScrubberLock(null);
            return;
        }

        if (activeSwingId === pendingScrubberLock.sourceSwingId) {
            return;
        }

        if (!activeVideo.length) {
            return;
        }

        const targetFrame = resolveTargetFrameFromPosition(
            pendingScrubberLock.position,
            activeSegmentationsMap,
            totalFrames,
        );

        setProgress(targetFrame == null ? 0 : (targetFrame * MAX_PROGRESS) / totalFrames);
        setPendingScrubberLock(null);
    }, [
        activeSegmentationsMap,
        activeSwingId,
        activeVideo,
        pendingScrubberLock,
        scrubberLock,
        setPendingScrubberLock,
        setProgress,
        totalFrames,
    ]);
};
